var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopeUserWrite = function SvgScopeUserWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.906 8.944H6.094c-.785 0-1.178 0-1.497.096a2.24 2.24 0 0 0-1.5 1.482C3 10.837 3 11.225 3 12m7.031-7.5C10.031 5.88 8.898 7 7.5 7S4.969 5.88 4.969 4.5 6.102 2 7.5 2s2.531 1.12 2.531 2.5M8.117 12.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 0 1 1.24 1.242l-4.099 4.1c-.091.09-.137.136-.19.171a.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L8 14z"
  })));
};
export default SvgScopeUserWrite;